import { render, staticRenderFns } from "./ServiceCardComponent.vue?vue&type=template&id=5d73a2aa&scoped=true&"
import script from "./ServiceCardComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCardComponent.vue?vue&type=style&index=0&id=5d73a2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73a2aa",
  null
  
)

export default component.exports